const GET_INSTANCE_WAIT_DURATION = 2500;

export { GET_INSTANCE_WAIT_DURATION };
//# sourceMappingURL=constants.js.map
